/*
  Bonny & Rose: "recently viewed" mag een model maar één keer tonen.

  Elke kleur is een eigen product, dus wie drie kleuren van dezelfde jurk bekijkt
  krijgt die jurk anders drie keer in het rijtje. Dit script doet twee dingen:

  1. Op een productpagina haalt het de andere kleuren van dít model uit het
     opgeslagen lijstje weg, zodat alleen de kleur blijft staan die je nu bekijkt.
     De adressen van die andere kleuren staan al in de kleurstalen op de pagina.

  2. In het rijtje zelf gooit het kaarten weg die hetzelfde model tonen. Dat
     vangt lijstjes op die al bestonden voordat dit script er was. Een titel is
     hier altijd "<model> — <kleur>", dus het stuk voor het streepje is het model.

  Het thema bewaart het lijstje op drie plekken: localStorage 'theme-recent',
  sessionStorage 'recent-products' en het object theme.recentlyViewed.recent.
  Alle drie worden bijgewerkt, anders komt de oude stand alsnog terug.
*/
(function () {
  'use strict';

  var RECENT_KEY = 'theme-recent';
  var INFO_KEY = 'recent-products';

  function safeParse(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  /* Het model uit een titel: alles vóór het lange streepje. Staat er geen
     streepje in, dan geldt de hele titel als model. */
  function modelOf(title) {
    if (!title) return '';
    return title.split('—')[0].split(' - ')[0].trim().toLowerCase();
  }

  /* Stap 1: de andere kleuren van deze pagina uit het lijstje halen. */
  function pruneStorage() {
    var row = document.querySelector('[data-br-swatches]');
    if (!row) return [];

    var current = null;
    var siblings = [];
    var links = row.querySelectorAll('[data-br-swatch]');

    for (var i = 0; i < links.length; i++) {
      var handle = links[i].getAttribute('data-handle');
      if (!handle) continue;
      if (links[i].getAttribute('aria-current') === 'true') {
        current = handle;
      } else {
        siblings.push(handle);
      }
    }

    if (!siblings.length) return [];

    var recent = safeParse(window.localStorage ? window.localStorage.getItem(RECENT_KEY) : null);
    if (recent) {
      var changed = false;
      for (var j = 0; j < siblings.length; j++) {
        if (siblings[j] !== current && Object.prototype.hasOwnProperty.call(recent, siblings[j])) {
          delete recent[siblings[j]];
          changed = true;
        }
      }
      if (changed) {
        try {
          window.localStorage.setItem(RECENT_KEY, JSON.stringify(recent));
        } catch (e) {}
      }
    }

    /* Het thema leest het lijstje één keer in bij het opstarten. Staat dat
       object er al, dan moet het mee, anders tekent het de oude stand. */
    if (window.theme && theme.recentlyViewed && theme.recentlyViewed.recent) {
      for (var k = 0; k < siblings.length; k++) {
        if (siblings[k] !== current) delete theme.recentlyViewed.recent[siblings[k]];
      }
    }

    var info = safeParse(window.sessionStorage ? window.sessionStorage.getItem(INFO_KEY) : null);
    if (info) {
      for (var m = 0; m < siblings.length; m++) {
        if (siblings[m] !== current) delete info[siblings[m]];
      }
      try {
        window.sessionStorage.setItem(INFO_KEY, JSON.stringify(info));
      } catch (e) {}
      if (window.theme && theme.recentlyViewed) theme.recentlyViewed.productInfo = info;
    }

    return siblings;
  }

  /* Stap 2: het getekende rijtje nalopen, herhalingen weghalen en de kleur uit
     de titel halen.

     Dit rijtje wordt door het thema in JavaScript opgebouwd, niet in Liquid, dus
     de aanpassing die de kaarten elders al kort houdt komt hier niet vanzelf
     terecht. Alles achter het laatste lange streepje is de kleur. */
  function pruneGrid(grid) {
    if (!grid) return;
    var seen = {};
    var cards = grid.children;

    for (var i = cards.length - 1; i >= 0; i--) {
      var card = cards[i];
      var titleEl = card.querySelector('.grid-product__title');
      var model = modelOf(titleEl ? titleEl.textContent : '');
      if (!model) continue;
      if (seen[model]) {
        card.parentNode.removeChild(card);
      } else {
        seen[model] = true;
        korten(titleEl);
      }
    }
  }

  /* De kleur van de titel afhalen, zonder een modelnaam met een streepje erin
     te breken: alleen het laatste stuk gaat eraf. */
  function korten(el) {
    if (!el) return;
    var tekst = el.textContent.trim();
    var knip = tekst.lastIndexOf(' — ');
    if (knip <= 0) return;
    var kort = tekst.slice(0, knip).trim();
    if (kort && kort !== tekst) el.textContent = kort;
  }

  function watchGrid() {
    var grids = document.querySelectorAll('[id^="RecentlyViewed-"]');
    if (!grids.length) return;

    for (var i = 0; i < grids.length; i++) {
      (function (grid) {
        /* Het thema vult dit rijtje pas als het in beeld komt, en dat kan lang
           duren op een lange pagina. Er staat daarom geen klok op: we kijken mee
           tot het rijtje er werkelijk is en stoppen dan.

           De waarnemer moet los staan terwijl we zelf kaarten weghalen, anders
           roept onze eigen wijziging hem opnieuw op en blijft dat rondgaan. */
        var busy = false;

        var observer = new MutationObserver(function () {
          if (busy) return;
          busy = true;
          observer.disconnect();
          pruneGrid(grid);
          busy = false;
          if (grid.children.length > 0) return;
          observer.observe(grid, { childList: true });
        });

        pruneGrid(grid);
        if (grid.children.length === 0) {
          observer.observe(grid, { childList: true });
        }
      })(grids[i]);
    }
  }

  function start() {
    pruneStorage();
    watchGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Bij een kleurwissel haalt het thema de productsectie opnieuw op en zet die
     in de plaats van de oude. Alles wat hierboven aan de pagina is gehangen is
     dan weg, dus dit moet daarna opnieuw. De sectie meldt dat zelf met
     shopify:section:load. */
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(start, 0);
  });

})();
